export class UIStateModel {
    public sidebarVisible: boolean = false;
}
